import React from 'react';
import { Chip } from '@mui/material';
import { useTranslate } from 'react-admin';

type SessionResource = 'active-sessions' | 'charging-sessions';

const COLOR: Record<string, 'primary' | 'secondary' | 'warning' | 'info' | 'success'> = {
  app: 'primary',
  rfid: 'secondary',
  admin: 'warning',
  backend_standalone: 'warning',
  backend_on_behalf: 'warning',
  ocpp: 'info',
  vendor_api: 'info',
  kiosk: 'success',
};

export const InitiatedByChip = ({ initiatedBy, resource }: { initiatedBy: string; resource: SessionResource }) => {
  const translate = useTranslate();
  return (
    <Chip
      label={translate(`resources.${resource}.types.${initiatedBy}`, { _: initiatedBy?.toUpperCase() || 'UNKNOWN' })}
      color={initiatedBy in COLOR ? COLOR[initiatedBy] : 'default'}
      size="small"
      variant="outlined"
    />
  );
};
